import React from 'react';

import { BaseIconProps } from '.';

export const EyeHidden = ({ fill }: BaseIconProps) => (
  <g
    id="noun_hidden_4406219"
    transform="matrix(58.744521,0,0,58.744521,-164.12659,-219.34307)"
  >
    <path
      id="Path_2619"
      data-name="Path 2619"
      d="M 21.95,12.4 C 21.788,12.184 17.913,7.094 12.942,7.094 A 8.638,8.638 0 0 0 9.124,8.055 l -1.89,-1.89 a 0.757,0.757 0 1 0 -1.07,1.07 l 12.487,12.487 a 0.757,0.757 0 0 0 1.07,-1.07 L 18.115,17.045 A 17.05,17.05 0 0 0 21.951,13.488 0.909,0.909 0 0 0 21.95,12.4 Z M 10.674,9.6 a 3.985,3.985 0 0 1 3.752,-0.429 1.641,1.641 0 1 0 2.284,2.284 3.988,3.988 0 0 1 -0.428,3.752 z"
      transform="translate(-0.956)"
      fill={fill}
    />
    <path
      id="Path_2620"
      data-name="Path 2620"
      d="M 11.987,18.572 A 4.043,4.043 0 0 1 8.094,13.41 L 5.819,11.135 a 17.14,17.14 0 0 0 -2.84,2.84 0.908,0.908 0 0 0 0,1.09 c 0.162,0.218 4.037,5.306 9.008,5.306 a 8.041,8.041 0 0 0 2.611,-0.456 l -1.5,-1.5 a 4.045,4.045 0 0 1 -1.111,0.157 z"
      transform="translate(0,-1.579)"
      fill={fill}
    />
  </g>
);
